import React from 'react';

const Footer = () => {
    return (
        <div className='text-white d-flex align-items-center justify-content-center' style={{height:'500px', backgroundColor: '#212529'}}>
            <p>Mckenzie Construction & Site Development LLC. Copyright 2021. All Rights Reserved.</p>
        </div>
    );
};

export default Footer;